import { getUserMentionLabel } from '#pplx/frontend/apps/ask/user-mentions/getUserMentionLabel.js';
import { getUserMentionUrl } from '#pplx/frontend/apps/ask/user-mentions/userMentionUrl.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export function getUserMentionOptions({ members, onSelect, }) {
    return members
        .filter((member) => 'org_user_uuid' in member)
        .map((member) => ({
        uuid: member.org_user_uuid,
        variant: 'user',
        label: getUserMentionLabel(member.full_name, member.email),
        subtitle: member.email,
        url: getUserMentionUrl(member.email),
        searchAliases: [member.email],
        action: onSelect,
        icon: member.image
            ? { type: 'image', url: member.image }
            : { type: 'icon', icon: $icon('user') },
    }));
}
//# sourceMappingURL=getUserMentionOptions.js.map